import React from 'react';
import { Badge } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import TickIcon from 'app/images/icons/tick.svg';
import ProcessingIcon from 'app/images/icons/refresh.svg';

import {
  parsePaymentStatusText, parseBadgeColor, parseAmountColor,
} from 'app/utils/parsers';

interface IProps {
  formattedPaymentText: string;
  numberOfObjects: number;
  paymentText: string;
  amountText: string;
  dueDate: string;
  className: string;
  defaultText: string;
  tick: boolean;
  noActive: boolean;
}
export default class StatusBadge extends React.PureComponent<IProps> {
  static defaultProps = {
    formattedPaymentText: undefined,
    numberOfObjects: undefined,
    paymentText: undefined,
    amountText: undefined,
    dueDate: null,
    noActive: false,
    className: undefined,
    defaultText: 'Unpaid',
    tick: true,
  };

  parsePaymentStatusColour = (
    status = 'pending',
    otherTeamStatus = 'pending',
    defaultColour = 'grey',
  ) => {
    let parsedColour = defaultColour;
    if (status === 'paid') {
      parsedColour = 'purple';
    }
    if (status === 'cancelled') {
      parsedColour = 'black';
    }
    if (status === 'inactive') {
      parsedColour = 'red';
    }
    if (status === 'active') {
      parsedColour = 'green';
    }
    if (status === 'paid-cash') {
      parsedColour = 'orange';
    }
    if (status === 'paid-bank-transfer') {
      parsedColour = 'blue';
    }
    if (status === 'paid-other') {
      parsedColour = 'yellow';
    }
    if (status === 'paid-eftpos') {
      parsedColour = 'blue';
    }
    if (status === 'paid-prepaid') {
      parsedColour = 'yellow';
    }
    if (status === 'paid-transferred') {
      parsedColour = 'purple';
    }
    if (status === 'paid-refunded') {
      parsedColour = 'purple';
    }
    if (status === 'pending') {
      parsedColour = 'grey';
    }
    if (status === 'transfer-required') {
      parsedColour = 'dark-purple';
    }
    if (status === 'transferred') {
      parsedColour = 'purple';
    }
    if (status === 'refunded') {
      parsedColour = 'black';
    }
    if (status === 'no-show' || otherTeamStatus === 'walkover') {
      parsedColour = 'black';
    }
    if (status === 'walkover' || otherTeamStatus === 'walkover') {
      parsedColour = 'black';
    }
    return parsedColour;
  }

  render(): React.ReactNode {
    const paymentText = this.props.formattedPaymentText || parsePaymentStatusText(this.props.paymentText, '', this.props.defaultText, this.props.noActive, this.props.dueDate);
    let badgeColor;
    let checked;
    let processing;
    if (this.props.amountText !== undefined) {
      [badgeColor, checked, processing] = parseAmountColor(paymentText);
    } else {
      [badgeColor, checked, processing] = parseBadgeColor(paymentText);
    }
    if (this.props.amountText !== undefined) {
      return (
        <Badge
          className={`${this.props.className} payment-badge`}
          color={badgeColor}
        >
          <span className="payment-text">
            {paymentText}
          </span>
          <div className="badge-alternate">
            {this.props.amountText}
          </div>
          {this.props.numberOfObjects !== undefined && (`${this.props.numberOfObjects} `)}
          {this.props.tick && checked && <Isvg className="tick" src={TickIcon} />}
          {this.props.tick && processing && <Isvg className="processing" src={ProcessingIcon} />}
        </Badge>
      );
    }
    return (
      <Badge
        className={`${this.props.className} payment-badge`}
        color={badgeColor}
      >
        {this.props.numberOfObjects !== undefined && (`${this.props.numberOfObjects} `)}
        {paymentText}
        {this.props.tick && checked && <Isvg className="tick" src={TickIcon} />}
        {this.props.tick && processing && <Isvg className="processing" src={ProcessingIcon} />}
      </Badge>
    );
  }
}
